import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import DrivingLicenceOutputComponent from '../output/DrivingLicenceOutputComponent';

// Tartan's driver-license-advanced endpoint wants dd/mm/yyyy. The form collects
// the unambiguous ISO form instead — same as the DL v2 page next door, so a DSA
// filling both doesn't have to switch conventions mid-flow — and converts on the
// way out. Anything that isn't ISO is passed through untouched for the backend
// to judge.
const toDdMmYyyy = (iso) => {
    const [y, m, d] = String(iso || '').split('-');
    return y && m && d ? `${d}/${m}/${y}` : iso;
};

const DrivingLicenceInputComponent = ({ serviceId, serviceDetails, leadId }) => (
    <SimpleReportForm
        serviceId={serviceId}
        serviceDetails={serviceDetails}
        leadId={leadId}
        banner={{ icon: 'pi-car', title: 'Driving Licence Verification', subtitle: 'Verify driving licence details with the Transport Department' }}
        fields={[
            { name: 'card_number', label: 'DL Number', icon: 'pi-id-card', placeholder: 'MH01-20100000000', maxLength: 20, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true },
            { name: 'dob', label: 'Date of Birth', icon: 'pi-calendar', placeholder: 'YYYY-MM-DD', maxLength: 10, mono: true,
              regex: /^\d{4}-\d{2}-\d{2}$/, regexError: 'Format: YYYY-MM-DD' },
            { name: 'pan', label: 'PAN (optional)', icon: 'pi-credit-card', placeholder: 'ABCDE1234F', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true,
              required: false },
            { name: 'mobile', label: 'Mobile (optional)', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true,
              required: false },
        ]}
        endpoint={{
            path: '/tartan/driving-licence/verify',
            bodyMapper: (v, sid, lid) => ({
                card_number: v.card_number, dob: toDdMmYyyy(v.dob),
                ...(v.pan && { pan: v.pan }),
                ...(v.mobile && { mobile: v.mobile }),
                api_provider_service_id: parseInt(sid, 10), application_id: 'bureaubox',
                ...(lid ? { lead_id: parseInt(lid, 10) } : {}),
            }),
        }}
        consentReportType="driving-licence"
        submitLabel="Verify Driving Licence"
        successSummary="Driving licence verified"
        errorSummary="Driving licence verification failed"
        confirmHeader="Confirm driving licence verification"
        confirmAcceptLabel="Yes, verify"
        outputComponent={DrivingLicenceOutputComponent}
    />
);

export default DrivingLicenceInputComponent;
